import { useMutation, useQueryClient } from 'react-query';
import { SOURCE } from '../../../constants';
import { useServices } from '../../../services/useServices';
import { useActions } from '../../../../context/Actions.context';

export const useReturn = ({ book_ids, tabId, source }) => {
  const { book: { returnTitle } } = useServices();
  const { setActionLoading } = useActions();
  const queryClient = useQueryClient();
  const params: { [key: string]: any } = {};

  if (source === SOURCE.bookstat) {
    params.amazonasin = book_ids;
  } else if (source === SOURCE.ao3) {
    params.work_id = book_ids;
  }
  else if (source === SOURCE['royal-road']) {
    params.fiction_id = book_ids;
  }

  return useMutation(
    'return-title',
    (body?: Record<string, unknown>) =>
      returnTitle(tabId, source, { params, body }),
    {
      onSuccess: data => {
        if (data.status === 200) {
          queryClient.refetchQueries(`get-row-count${tabId}`);
          queryClient.refetchQueries(`get-${tabId}`);
        }
      },
      onSettled: () => {
        setActionLoading(false);
      }
    }
  );
};